/* eslint-disable @stylistic/brace-style */
import { Page } from "../enums/Page";
import { css, html } from "../helpers/webComponents";
import { GameEventService } from "../services/GameEventService";

const styles: string = css`
    * {
        font-family: "Onesize";
    }
    .parent-div {
        width: 40%;
        position: fixed;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        border: 1px solid;
        padding: 24px;
        box-shadow: 4px 4px 10px;
    }

    h2 {
        margin: 0px;
    }

    p {
        opacity: 70%;
    }

    .input-parent {
        display: flex;
        flex-direction: column;
        gap: 2px;
        margin-bottom: 8px;
    }

    input {
        font-size: 20px;
        outline: none;
        border-radius: 8px;
        padding: 4px;
        width: 50%;
    }

    .error-message {
        color: #ff0000;
        font-size: 16px;
        margin: 0px;
        display: none;
    }

    .buttons {
        display: flex;
        gap: 8px;
        flex-wrap: wrap;
    }

    button {
        cursor: pointer;
        border-radius: 10px;
        padding: 5px 10px;
        background-color: #4b628b81;
        border: none;
        color: white;
        text-transform: uppercase;
        font-size: 22px;
    }

    button:disabled {
        cursor: default;
        opacity: 60%;
    }

    button:disabled:hover {
        background-color: #4b628b81;
    }

    button:hover {
        background-color: #332c57;
    }
`;

import { UseOwnNameResponse, UseOwnNameService } from "../services/UseOwnNameService";

export class UseOwnNameComponent extends HTMLElement {
    private _gameEventService: GameEventService = new GameEventService();
    private _useOwnNameService: UseOwnNameService = new UseOwnNameService(); // 🔹 Service aanroepen

    public connectedCallback(): void {
        this.attachShadow({ mode: "open" });
        this.render();
    }

    private render(): void {
        if (!this.shadowRoot) return;
        const element: HTMLElement = this.renderInputfield();
        this.shadowRoot.firstChild?.remove();
        this.shadowRoot.appendChild(element);
    }

    private renderInputfield(): HTMLElement {
        const element: HTMLElement = html`
        <div>
            <style>${styles}</style>
            <div class="parent-div">
                <h2>Use your own custom player name!</h2>  
                <p>If you use a custom player name, it will appear in certain interactions. <i>How Cool is that!</i>. <br><br> If you don't use your custom player name, you will be called "Mr. Graves".</p>  
                
                <div class="input-parent">
                    <input type="text" class="input-field" placeholder="Your playername"></input>
                    <p class="error-message"></p>
                </div>
                
                <div class="buttons">
                    <button id="use_custom_name_button" disabled>Use custom name</button>
                    <button id="use_standard_name_button">Use "Mr. Graves"</button>
                    <button id="cancel_button">Go back</button>
                </div>
            </div>
        </div>`;

        const inputElement: HTMLInputElement = element.querySelector(".input-field") as HTMLInputElement;
        const errorMessage: HTMLElement = element.querySelector(".error-message") as HTMLElement;
        const customNameButton: HTMLButtonElement = element.querySelector("#use_custom_name_button") as HTMLButtonElement;

        inputElement.addEventListener("input", () => {
            const playerName: string = inputElement.value.trim();
            if (playerName.length === 0) {
                errorMessage.style.display = "none";
                customNameButton.setAttribute("disabled", "");
            } else if (playerName.length < 4) {
                errorMessage.textContent = "The name is too short!";
                errorMessage.style.display = "block";
                customNameButton.setAttribute("disabled", "");
            } else if (playerName.length > 15) {
                errorMessage.textContent = "The name is too long!";
                errorMessage.style.display = "block";
                customNameButton.setAttribute("disabled", "");
            } else {
                errorMessage.style.display = "none";
                customNameButton.removeAttribute("disabled");
            }
        });

        element.querySelector("#use_custom_name_button")?.addEventListener("click", async () => {
            const playerName: string = inputElement.value.trim();

            const response: UseOwnNameResponse = await this._useOwnNameService.setPlayerName(playerName);

            if (!response.success) {
                alert(`Failed to set player name: ${response.error || "Unknown error"}`);
                return;
            }
            this._gameEventService.switchPage(Page.Canvas);
        });

        element.querySelector("#use_standard_name_button")?.addEventListener("click", async () => {
            const response: UseOwnNameResponse = await this._useOwnNameService.setPlayerName("Mr. Graves");

            if (!response.success) {
                alert(`Failed to set player name: ${response.error || "Unknown error"}`);
                return;
            }
            this._gameEventService.switchPage(Page.Canvas);
        });

        element.querySelector("#cancel_button")?.addEventListener("click", () => {
            this._gameEventService.switchPage(Page.Canvas);
        });

        return element;
    }
}
